import MButton from './button.vue'

export default MButton
